import { useRef, useState } from "react";
import { Avatar } from "../ui/Avatar";
import { Button } from "../ui/Button";
import { Dialog } from "../ui/Dialog";
import { useAuth } from "context/AuthContext";
import { ImpersonationDialog } from "../ImpersonationDialog";
import { Shield, User, LogOut } from "lucide-react";

export function UserMenu() {
  const [open, setOpen] = useState(false);
  const [impersonationDialogOpen, setImpersonationDialogOpen] = useState(false);

  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const {
    teacherName,
    currentPlan,
    logout,
    isSuperuser,
    isImpersonating,
    stopImpersonation,
  } = useAuth();

  return (
    <div className="relative mt-auto">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="w-8 h-8 lg:w-10 lg:h-10 rounded-full hover:bg-gray-200 flex items-center justify-center relative"
        title="User menu"
        ref={buttonRef}
      >
        <Avatar size="sm"></Avatar>
        {isImpersonating && (
          <div className="absolute -top-1 -right-1 w-3 h-3 lg:w-4 lg:h-4 bg-red-600 rounded-full border-2 border-white"></div>
        )}
      </button>

      <Dialog
        open={open}
        triggerRef={buttonRef}
        onClose={() => setOpen(false)}
        position="top-start"
      >
        <div className="space-y-3 lg:space-y-4">
          <div>
            <p className="text-xs lg:text-sm text-gray-600 break-all">
              {teacherName}
            </p>
            <p className="text-xs text-gray-500 mt-1">{currentPlan}</p>
            {isSuperuser && (
              <div className="flex items-center space-x-1 mt-1">
                <Shield className="w-3 h-3 text-blue-600" />
                <span className="text-xs text-blue-600">Superuser</span>
              </div>
            )}
          </div>

          {isSuperuser && !isImpersonating && (
            <Button
              onClick={() => {
                setImpersonationDialogOpen(true);
                setOpen(false);
              }}
              variant="primary"
              size="sm"
              className="w-full text-xs lg:text-sm"
            >
              <User className="w-3 h-3 lg:w-4 lg:h-4 mr-1 lg:mr-2" />
              Impersonate Teacher
            </Button>
          )}

          {isImpersonating && (
            <Button
              onClick={() => {
                stopImpersonation();
                setOpen(false);
              }}
              variant="primary"
              size="sm"
              className="w-full text-xs lg:text-sm text-red-600 border-red-300 hover:bg-red-50"
            >
              <LogOut className="w-3 h-3 lg:w-4 lg:h-4 mr-1 lg:mr-2" />
              Stop Impersonation
            </Button>
          )}

          <Button
            onClick={() => {
              logout();
              setOpen(false);
            }}
            size="sm"
            className="w-full text-xs lg:text-sm"
          >
            Sign Out
          </Button>
        </div>
      </Dialog>

      <ImpersonationDialog
        open={impersonationDialogOpen}
        onClose={() => setImpersonationDialogOpen(false)}
      />
    </div>
  );
}
